export const isIframe = () => {
  return window.self !== window.top;
};

export const isNestedIframe = () => {
  return window.self !== window.top && window.parent !== window.top;
};
